export default __webpack_public_path__ + "static/media/map-wind.ee17420c.svg";